import { LocaleCodeSchema, type LocaleCode } from './types';

export function isLocaleCode(code: string): code is LocaleCode {
   return LocaleCodeSchema.safeParse(code).success;
}
